<template>
  <li class="image-card" v-bind:class="'image-card-' + selected" @click="doClick(image)">
    <img class="image-card__image" :id="image.id" :src="image.url_n" :alt="image.title">
    <div class="image-card__body">
      <p v-if="image.title" class="image-title">{{image.title}}</p>
      <p v-else class="image-title">No Title Found</p>
      <p class="image-owner" v-if="image.ownername && image.ownername != null">By {{image.ownername}}</p>
      <section class="image-date-view-wrapper">
        <p class="image-date" v-if="image.datetaken && image.datetaken != null">{{image.datetaken}}</p>
        <p class="image-views"  v-if="image.views && image.views != null">Views: {{image.views}}</p>
      </section>
      <!-- Image original source: image.url_n-->
    </div>
  </li>
</template>

<script>
  export default {
    name: 'ImageCard',
    props: {
      image: {
        required: false,
        type: Object,
        default: null
      },
      selected: {
        required: false,
        type: Boolean,
        default: null
      },
    },
    methods: {
      doClick(image) {
        this.$emit("onclicked",image)
      }
    } 
  }
</script>

<style scoped>
  .image-card {
    width: calc(33% - 1rem);
    margin: .5rem;
    border-radius: 5px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, .15);
    background: white;

    @media only screen and (max-width: 799px) {
      width: calc(50% - 1rem);
    }

    @media only screen and (max-width: 549px) {
      width: 100%;
      margin: .5rem 0;
    }
  }

  .image-card__image {
    border-radius: 5px 5px 0 0;
    width: 100%;
    height: 200px;
    object-fit: cover;
  }

  .image-card__body {
    padding: .5rem 1rem 1rem;
  }

  .image-title {
    font-weight: bold;
    margin: 0;
  }

  .image-owner {
    margin-top: 0;
    font-size: .8rem;
  }

  .image-title,
  .image-owner {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .image-date-view-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .image-date,
  .image-views {
    margin-bottom: 0;
    font-size: .8rem;
  }

  .image-card-true {
    box-shadow: 0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);
    cursor: pointer;
  }

  .image-card:hover {
    box-shadow: 0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/imagehandling/image-card.vue